import {
  confirmable,
  createConfirmation,
} from 'react-confirm';

interface ConfirmDialogProps {
  okLabel?: string;
  cancelLabel?: string;
  title?: string;
  confirmation?: string;
  description?: string;
};

const ConfirmDialog = ({ okLabel, cancelLabel, title, confirmation, description, show, proceed }: ConfirmDialogProps & { show: boolean; proceed: (result: boolean) => void }) => (
  <wa-dialog label={title || 'Are you sure?'} className="dialog-overlay" open={show}>
    {confirmation && (
      <p>{confirmation}</p>
    )}
    {description && (
      <p>{description}</p>
    )}
    <wa-button slot="footer" variant="neutral" appearance="outlined" onClick={() => proceed(false)}>
      {cancelLabel || 'Cancel'}
    </wa-button>
    <wa-button slot="footer" variant="danger" onClick={() => proceed(true)}>
      {okLabel || 'OK'}
    </wa-button>
  </wa-dialog>
);

export const confirm = createConfirmation(confirmable(ConfirmDialog));
